export default __webpack_public_path__ + "static/client-details-1-ba48ae293807f0b02057a68760556295.png";